const consts = {
    baseUri: process.env.NODE_ENV==='production'?"/APopupsGalleryDemo/":"/dist/"
}
export {
    consts
}